<template>
  <Loader />
  <div id="callback" >
    <input
      type="hidden"
      id="access_token"
      name="access_token"
      v-model="token"
    />
    <input
      type="hidden"
      id="user_status"
      name="user_status"
      :value="user_status"
    />
    <input
      type="hidden"
      id="google_signin"
      name="google_signin"
      :value="google_signin"
    />

    <input
      type="hidden"
      id="email"
      name="email"
      :value="email"
    />

    <input
      type="hidden"
      id="name"
      name="name"
      :value="name"
    />
    <input
      type="hidden"
      id="avatar"
      name="avatar"
      :value="avatar"
    />
    <input
      type="hidden"
      id="msisdn"
      name="msisdn"
      :value="msisdn"
    />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from 'vue-router';
import Loader from "../../components/Loader.vue";
import { useAuthStore } from '@/store/auth'; // استيراد الـ Auth Store
import { useAuthFlow } from '@/views/Auth/useAuthFlow';

const route = useRoute();
const router = useRouter();
const token = ref("");
const user_status = ref("");
const google_signin = ref("");
const email = ref("");
const name = ref("");
const avatar = ref("");
const msisdn = ref("");
const { resolveFlow, executeFlow } = useAuthFlow();
const auth = useAuthStore(); // تهيئة الـ Auth Store

onMounted(async () => {
  let finalToken = localStorage.getItem("token");

  if (!finalToken) {
    console.warn("No token found after callback. Redirecting to login.");
    router.push({ name: 'login' });
    return;
  }

  token.value = finalToken;
  user_status.value = localStorage.getItem("user_status") || '';
  msisdn.value = localStorage.getItem("msisdn") || ''; 

  // الخطوة الرابعة: جلب بيانات المشترك الحقيقية من السيرفر باستخدام التوكن
  try {
    const res = await auth.getSubscriberDetails();
    if (res.success && res.data?.success?.details) {
      const details = res.data.success.details;
      msisdn.value = details.msisdn || msisdn.value;
      name.value = details.name || '';
    }
  } catch (err) {
    console.error("Failed to fetch subscriber details:", err);
  }

  google_signin.value = route.query.google_signin || '';
  email.value = route.query.email || '';
  avatar.value = route.query.avatar || '';

  // تنفيذ الـ setAttribute للـ input كما طُلب لضمان تواجد القيمة للاسكربتات الخارجية
  const hiddenInput = document.getElementById("access_token");
  if (hiddenInput) {
    hiddenInput.value = finalToken;
  }

  // نترك اللودر يدور كما هو موجود في المتطلبات
});

</script>

<style>
#callback {
  background-position: center;
  background-size: cover;
}
</style>
